"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPOTNotification = void 0;
var React = require("react");
require("./SPOTNotification.scss");
exports.SPOTNotification = React.forwardRef(function (props) {
    var backgroundColor = props.background ? props.background : "filled";
    return (React.createElement("div", { id: props.id, className: "spot-notification" }, props.active && (React.createElement("div", { className: props.type + " " + backgroundColor },
        props.type === "error" && React.createElement("i", { className: "icon-attention-round" }),
        props.type === "warning" && React.createElement("i", { className: "icon-attention" }),
        React.createElement("p", null, props.text)))));
});
//# sourceMappingURL=SPOTNotification.js.map